import { render, staticRenderFns } from "./LeadStat.vue?vue&type=template&id=2aa2d4b4&scoped=true&"
import script from "./LeadStat.vue?vue&type=script&lang=js&"
export * from "./LeadStat.vue?vue&type=script&lang=js&"
import style0 from "./LeadStat.vue?vue&type=style&index=0&id=2aa2d4b4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aa2d4b4",
  null
  
)

export default component.exports